// eslint-disable-next-line
const includePrefix = '^(';
const includeSuffix = ')$';
const excludePrefix = '^(?!(';
const excludeSuffix = ')).*$';

const RuleMapper = {

  operatorMapperToQueryBuilder: {
    "Equal": "equals",
    "NotEqual": "does not equals",
    "IsMatch": {
      keyTransform: (rule) => {
        if (!rule.target_value) {
          return 'is match';
        }
        return rule.target_value.startsWith(includePrefix) && rule.target_value.endsWith(includeSuffix)
          ? 'include'
          : rule.target_value.startsWith(excludePrefix) && rule.target_value.endsWith(excludeSuffix)
            ? 'exclude'
            : 'is match';
      },
      targetTransform: (rule) => {
        if (!rule.target_value) {
          return rule.target_value;
        }
        return rule.target_value.startsWith(includePrefix) && rule.target_value.endsWith(includeSuffix)
          ? rule.target_value.replace(includePrefix, '').replace(includeSuffix, '')
          : rule.target_value.startsWith(excludePrefix) && rule.target_value.endsWith(excludeSuffix)
            ? rule.target_value.replace(excludePrefix, '').replace(excludeSuffix, '')
            : rule.target_value;
      }
    },
    "StartsWith": "begins with",
    "EndsWith": "ends with",
    "LessThan": "less than",
    "LessThanOrEqual": "less than or equals",
    "GreaterThan": "greater than",
    "GreaterThanOrEqual": "greater than or equals",
    "And": "all",
    "Or": "any"
  },

  operatorMapperToRule: {
    "equals": "Equal",
    "does not equals": "NotEqual",
    "include": { key: "IsMatch", targetTransform: (value) => `${includePrefix}${value}${includeSuffix}` },
    "exclude": { key: "IsMatch", targetTransform: (value) => `${excludePrefix}${value}${excludeSuffix}` },
    "begins with": "StartsWith",
    "ends with": "EndsWith",
    "less than": "LessThan",
    "less than or equals": "LessThanOrEqual",
    "greater than": "GreaterThan",
    "greater than or equals": "GreaterThanOrEqual",
    "all": "And",
    "any": "Or"
  },

  mapToQueryBuilder(rule) {
    let queryGroup = { "type": "query-builder-group" };
    queryGroup.logicalOperator = this.operatorMapperToQueryBuilder[rule.operator];

    if (rule.rules) {
      queryGroup.children = this.mapQueryChildren(rule.rules);
    } else {
      queryGroup.children = [];
    }
    return queryGroup;
  },
  mapToQueryBuilderElement(rule) {
    let query = {};
    if (!rule) {
      return query;
    }
    if (this.isNestedRule(rule)) {
      query = this.mapToQueryBuilderGroup(rule);
    } else {
      query = this.mapRuleToQueryBuilderRule(rule);
    }
    return query;
  },

  isNestedRule(rule) {
    return rule.operator === "And" || rule.operator === "Or";
  },

  mapToQueryBuilderGroup(rule) {
    let queryGroup = { "type": "query-builder-group", query: {} };
    queryGroup.query.logicalOperator = this.operatorMapperToQueryBuilder[rule.operator];

    if (rule.rules) {
      queryGroup.query.children = this.mapQueryChildren(rule.rules);
    } else {
      queryGroup.query.children = [];
    }

    return queryGroup;
  },

  mapQueryChildren(rules) {
    var queryRules = [];
    rules.forEach((rule) => {
      queryRules.push(this.mapToQueryBuilderElement(rule));
    });
    return queryRules;
  },

  mapRuleToQueryBuilderRule(rule) {
    let queryRule = { "type": "query-builder-rule" };
    queryRule.query = {
      "rule": rule.member_name,
      "selectedOperator": this.getQueryBuilderRuleOperator(rule),
      "selectedOperand": rule.member_name,
      "value": this.getQueryBuilderRuleTarget(rule)
    };
    return queryRule;
  },

  getQueryBuilderRuleOperator(rule) {
    const mapping = this.operatorMapperToQueryBuilder[rule.operator];
    if (mapping.keyTransform) {
      return mapping.keyTransform(rule);
    }
    return mapping;
  },

  getQueryBuilderRuleTarget(rule) {
    const mapping = this.operatorMapperToQueryBuilder[rule.operator];
    if (mapping.targetTransform) {
      return mapping.targetTransform(rule);
    }
    return rule.target_value;
  },

  mapToRuleRoot(query) {
    // Root rule does not have query object and type is query-builder-rule
    // but will always be a group rule
    const rootRule = this.mapToRuleGroup(query);
    return rootRule;
  },

  mapToRule(query) {
    let rule = {};
    if (!query) {
      return rule;
    }
    if (this.isNestedQuery(query.query)) {
      rule = this.mapToRuleGroup(query.query);
    } else {
      rule = this.mapQueryToRule(query);
    }
    return rule;
  },

  isNestedQuery(query) {
    return query.logicalOperator === "any" || query.logicalOperator === "all";
  },

  mapToRuleGroup(query) {
    let rule = {};
    rule.operator = this.operatorMapperToRule[query.logicalOperator];

    if (query.children) {
      rule.rules = this.mapRuleChildren(query.children);
    } else {
      rule.rules = [];
    }

    return rule;
  },

  mapRuleChildren(queries) {
    var rules = [];
    queries.forEach((query) => {
      if (query &&
        ((query.type === "query-builder-rule" && query.query.rule) ||
          (query.type === "query-builder-group" && query.query.logicalOperator))) {
        rules.push(this.mapToRule(query));
      }
    });
    return rules;
  },

  mapQueryToRule(query) {
    let rule = {
      "member_name": query.query.rule,
      "operator": this.getRuleOperator(query.query),
      "target_value": this.getRuleTarget(query.query)
    };
    return rule;
  },

  getRuleOperator(query) {
    const mapping = this.operatorMapperToRule[query.selectedOperator];
    if (mapping.key) {
      return mapping.key;
    }
    return mapping;
  },

  getRuleTarget(query) {
    const mapping = this.operatorMapperToRule[query.selectedOperator];
    if (mapping.targetTransform) {
      return mapping.targetTransform(query.value);
    }
    return query.value;
  }
};

export default RuleMapper;



// WEBPACK FOOTER //
// ./src/services/utilities/ruleMapper.js